module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.a8de8ffe.ttf";